/**
 * @param {Map<number|string, unknown>|Record<string, unknown>|null|undefined} teamPanelDataMap
 * @param {number|string|null|undefined} viewerProfileId
 */
export function hasViewerRootTeamPanelData(teamPanelDataMap, viewerProfileId) {
    if (viewerProfileId == null || viewerProfileId === "") {
        return false;
    }

    const entry =
        teamPanelDataMap instanceof Map
            ? teamPanelDataMap.get(viewerProfileId)
            : teamPanelDataMap?.[viewerProfileId];

    if (entry == null) {
        return false;
    }

    if (typeof entry === "object" && !Array.isArray(entry)) {
        return Object.keys(entry).length > 0;
    }

    return true;
}

/**
 * Root team-panel fetch can be skipped only when the viewer's map entry exists
 * and the store already finished a full prepare cycle.
 *
 * @param {{
 *   teamPanelDataPrepared: boolean,
 *   teamPanelDataMap: Map<number|string, unknown>,
 *   viewerProfileId: number|string|null|undefined,
 * }} input
 */
export function shouldSkipTeamPanelRootFetch(input) {
    return (
        input.teamPanelDataPrepared === true &&
        hasViewerRootTeamPanelData(
            input.teamPanelDataMap,
            input.viewerProfileId,
        )
    );
}
